/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./menu/internal/submenu/sub-menu-styles.css.
import {css} from 'lit';
export const styles = css`:host{position:relative;display:flex;flex-direction:column}
`;
export default styles.styleSheet!;
